module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/feed/news/news.component.css
// module id = ./src/app/articles/feed/news/news.component.css
// module chunks = main